import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap, Subject } from 'rxjs';
import { CaseModel } from '../models/case.model';
import { DocumentModel } from '../models/document.model';
import { ApiService } from './api.service';
import { ObjectModel } from '../models/object.model';
import { LogicResultModel } from '../models/logic.model';

@Injectable()
export class DocumentService {
  private _document$ = new BehaviorSubject<DocumentModel | null>(null);
  private _documentDisconnectedFromTXdocsAnswerPoolSubject = new BehaviorSubject<boolean>(false);

  constructor(private apiService: ApiService) {}

  get documentDisconnectedFromTXdocsAnswerPool$() {
    return this._documentDisconnectedFromTXdocsAnswerPoolSubject.asObservable();
  }

  get documentDisconnectedFromTXdocsAnswerPool(): boolean {
    return this._documentDisconnectedFromTXdocsAnswerPoolSubject.value;
  }

  get document$(): Observable<DocumentModel | null> {
    return this._document$;
  }

  getDocumentList(model: CaseModel): Observable<any> {
    return this.apiService.post('document/getdocumentlist', model, {
      showToast: true,
    });
  }

  documentWasLoaded(model: DocumentModel) {
    this._document$.next(model);
  }

  getDocument(model: DocumentModel): Observable<any> {
    return this.apiService
      .post<DocumentModel>('document/getdocument', model, {
        showToast: true,
      })
      .pipe(
        tap((response) => {
          this._document$.next(response);
        })
      );
  }

  getDocumentBySession(model: DocumentModel): Observable<any> {
    return this.apiService.post('document/getdocumentbysession', model, {
      showToast: true,
    });
  }

  saveDocument(model: DocumentModel): Observable<any> {
    // we don't want to send the answers back to the server
    model.answers = [];
    return this.apiService.post('document/savedocument', model, {
      showToast: true,
    });
  }

  openDocumentInNewSession(model: DocumentModel): Observable<any> {
    return this.apiService
      .post<DocumentModel>('document/opendocumentinnewsession', model, {
        showToast: true,
      })
      .pipe(
        tap((response) => {
          this._document$.next(response);
        })
      );
  }

  downloadDocument(
    txTextSessionId: string,
    downloadAsPdf: boolean,
    fileName: string,
    documentTemplateId: number,
    praSysId: number,
    logicResults: LogicResultModel[]
  ): Observable<any> {
    return this.apiService.post(
      'document/downloaddocument',
      {
        txTextSessionId: txTextSessionId,
        downloadAsPdf: downloadAsPdf,
        fileName: fileName,
        templateId: documentTemplateId,
        praSysId: praSysId,
        logicResults: logicResults
      },
      { showToast: false }
    );
  }

  //log print to meta data
  printDocument(templateId: number | undefined): Observable<any> {
    return this.apiService.post('document/printdocument', { templateId: templateId }, { showToast: false });
  }

  setDocumentDisconnected(value: boolean) {
    this._documentDisconnectedFromTXdocsAnswerPoolSubject.next(value);
  }
}
